
import React from "react";
import { Link } from "react-router-dom";
import ContactForm from "../Form/ContactForm";
import Breadcrumb from "react-bootstrap/Breadcrumb";
import { useSelector } from "react-redux";
import { Image_Url } from "../../Constant/Environment";
import { getFullUrl } from "../../Constant/makeApiCall";
import MetaTags from '../MetaTags';

function Contact() {

  const { contactData } = useSelector((state) => state.contactData);
  // console.log(getFullUrl());
  return (
    <>
      <MetaTags
        title={contactData && contactData.meta_title}
        description={contactData && contactData.meta_descriptions}
        image={Image_Url + contactData.banner}
        canonicalUrl={getFullUrl()}
      />
      <div className="banner-inner">
        {contactData && contactData.banner ? (

          <img src={Image_Url + contactData.banner} alt="logo1" />
        ) : null}

        <div className="banner-text">
          <h3 className="c-heading">{contactData ? contactData.banner_title : ''}</h3>
          <p>
            {contactData ? contactData.banner_descriptions : ''}
          </p>
        </div>
      </div>

      <main className="middle contact-page">
        <section className="pt-3 sender">
          <div className="container">
            <Breadcrumb>
              <Breadcrumb.Item>Welcome</Breadcrumb.Item>
              <Breadcrumb.Item active>Contact Us</Breadcrumb.Item>
            </Breadcrumb>
            <div className="row g-5 sec-padd-t">
              <div className="col-md-7">
                <h2 className="c-heading">Drop Us a Line</h2>
                <p className="gray-color">
                  Get in touch via form below and we will reply as soos as we
                  can.
                </p>
                <ContactForm />
              </div>
              <div className="col-md-5">
                <div className="work-box h-auto mb-5 p-5">
                  <img
                    src={require("../../Assets/Images/box.webp")}
                    alt="logo2"
                  />
                  <h3>Drop a Mail</h3>
                  <h5>
                    <Link to="mailto:SocialShipping@gmail.com">
                      {contactData ? contactData.first_email : ''}
                    </Link>
                  </h5>
                  <h5>
                    <Link to="mailto:info.socialshipping@gmail.com">
                      {contactData ? contactData.second_email : ''}
                    </Link>
                  </h5>
                </div>
                <div className="work-box h-auto mb-5 p-5">
                  <img
                    src={require("../../Assets/Images/call.webp")}
                    alt="logo2"
                  />
                  <h3>Call Us</h3>
                  <h5>
                    <Link to={`tel:${contactData ? contactData.first_no : ''}`}>
                      {contactData ? contactData.first_no : ''}
                    </Link>
                    , <Link to={`tel:${contactData ? contactData.second_no : ''}`}>
                      {contactData ? contactData.second_no : ''}
                    </Link>
                  </h5>

                </div>
                <div className="work-box h-auto mb-5 p-5">
                  <img
                    src={require("../../Assets/Images/whatsapp.webp")}
                    alt="logo2"
                  />
                  <h3>Chat with us</h3>
                  <h5>
                    <Link to={`https://api.whatsapp.com/send?phone=${contactData ? contactData.whatsapp_no : ''}`}>
                      Start a conversation on WhatsApp {contactData ? contactData.whatsapp_no : ''}
                    </Link>
                  </h5>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="sec-padd">
          <div className="container">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3502.579341486233!2d77.20735924710138!3d28.61239388408227!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390cfd5b347eb62d%3A0x52c2b7494e204dce!2sNew%20Delhi%2C%20Delhi!5e0!3m2!1sen!2sin!4v1703840013952!5m2!1sen!2sin"
              width="100%"
              height="450"
              loading="lazy"
            ></iframe>
          </div>
        </section>
      </main>
    </>
  );
}

export default Contact;
